/* eslint-disable new-cap */
import axios from "axios";

const KEYS = {
  siteId: process.env.REACT_APP_CIO_SITEID,
  apiKey: process.env.REACT_APP_CIO_APIKEY,
};

const Endpoint = (identifier) =>
  `https://track.customer.io/api/v1/customers/${identifier}`;

const EndPointTracking = (identifier) =>
  `https://track.customer.io/api/v1/customers/${identifier}/events`;

const GetAuhenticationKey = () => {
  const { apiKey, siteId } = KEYS;
  return new Buffer.from(`${siteId}:${apiKey}`, "binary").toString("base64");
};

export default {
  updateProfilePayment: async (payload) => {
    const _payload = {
      account_state: "paying",
      country: payload.countryCode,
    };

    const key = GetAuhenticationKey();

    const options = {
      headers: {
        Authorization: `Basic ${key}`,
        "content-type": "application/json",
      },
    };

    try {
      await axios.put(Endpoint(payload.id), _payload, options);
    } catch (error) {
      throw error;
    }
  },
  pushTopUpEvent: async (payload) => {
    const _payload = {
      name: "top_up",
      data: {
        balance: payload.balance,
      },
    };

    const key = GetAuhenticationKey();

    const options = {
      headers: {
        Authorization: `Basic ${key}`,
        "content-type": "application/json",
      },
    };

    try {
      await axios.post(EndPointTracking(payload.id), _payload, options);
    } catch (error) {
      throw error;
    }
  },
};



// WEBPACK FOOTER //
// ./src/config/cio.js